/* A type-guard to identify if an entity is an organisation role */
export var isOrganisationRole = function (value) {
  return value && value.hasOwnProperty && value.hasOwnProperty('organisation') && value.hasOwnProperty('role');
};